import { userConstants } from "../../constant";

export function searchFilter(state = [], action) {
  switch (action.type) {
    case userConstants.SEARCH_QUERY_PARAMS:
      return action.searchFilter;

    default:
      return state;
  }
}
